/**
 * 更新翻译加载状态的能力
 */
export interface TranslateLoadingService {
    /**
     * 设置翻译结果加载状态
     */
    setLoadingTranslateResult(isLoading: boolean): void;
    /**
     * 设置重新生成翻译段落加载状态
     */
    setLoadingRegenerateTranslateFragment(isLoading: boolean): void;
    /**
     * 设置当前正在翻译的段落索引
     */
    setCurrentTranslateFragmentIndex(index: number): void;
    /**
     * 设置是否等待首次响应中
     */
    setWaitingFirstResponse(waiting: boolean): void;
}

export const TranslateLoadingService = Symbol('TranslateLoadingService');


